import axios from 'axios';

let tokenFunc: () => void;

export function post(uri: string, data: any) {
    return getIdToken().then(() => axios.post(uri, data));
}

export function put(uri: string, data: any) {
    return getIdToken().then(() => axios.put(uri, data));
}

export function remove(uri: string) {
    return getIdToken().then(() => axios.delete(uri));
}

export function get(uri: string, data = {}) {
    return getIdToken().then(() => axios.get(uri));
}

export function setToken(token: any) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

// designed to do a call back when required e.g. gettokenid
export function setTokenRefreshCall(tokenCallback: any) {
    tokenFunc = tokenCallback;
}

export function setBaseUrl(uri: string) {
    axios.defaults.baseURL = uri;
}

async function getIdToken() {
    if (tokenFunc) {
        const token = await tokenFunc;
        setToken(token);
    }
}

export function handleError(error: any) {
    if (error.response.data) {
        console.error(`Error while processing http call: ${JSON.stringify(error.response.data)}`);
    } else {
        console.error(`Error while processing http call: no further information`);
    }
}

// export function upload(uri:string, data:any) {
//     return 'need to implement';
//     // return fetch(uri, {
//     //     headers: getHeaders(true),
//     //     cors: true,
//     //     method: 'POST',
//     //     body: data
//     // })
// };